export default {
  "home": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["¡Hola!✨"])},
    "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["¿Cómo podemos ayudarte hoy? Estamos aquí para ti, ¡así que comencemos una conversación!"])}
  },
  "conversation": {
    "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Conversaciones actuales"])},
    "last_message_empty_caption": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nueva conversación..."])},
    "welcome_text": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["¡Hola! Bienvenido a ", _interpolate(_named("messengerName")), "."])},
    "enter_message_info": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ingrese su pregunta a continuación para que podamos responderla rápidamente."])},
    "compose": {
      "input_placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Escribe un mensaje..."])}
    },
    "survey": {
      "post": {
        "body": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nos encantaría saber qué piensas de esta conversación:"])},
        "thank_you_msg": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["¡Gracias por sus comentarios! Esto nos ayudará a mejorar nuestro servicio para usted y los demás"])}
      }
    },
    "status": {
      "sending": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Enviando..."])},
      "sent": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Enviado"])},
      "conversation_is_closed": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["La conversación está cerrada"])}
    },
    "errors": {
      "404": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["¡No se pudo cargar la conversación!"])}
    }
  },
  "archived_conversations": {
    "header": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Conversaciones archivadas (", _interpolate(_named("count")), ")"])}
  },
  "search": {
    "input_placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Buscar artículos de ayuda"])},
    "no_results": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["No hay resultados para \"", _interpolate(_named("query")), "\""])},
    "no_results_hint": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Intente con una palabra clave diferente"])}
  },
  "channels": {
    "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["¿Cómo te gustaría ponernos en contacto hoy?"])},
    "whatsapp": {
      "card_header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Enviar un mensaje de WhatsApp"])},
      "qr_code_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Escanea con la aplicación de tu cámara o haz clic en el código QR para iniciar una conversación."])},
      "button_text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Abrir WhatsApp"])},
      "number_undefined_error": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["El número no está definido."])},
      "initial_text_msg": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["¡Hola equipo! Me preguntaba..."])}
    }
  },
  "agents": {
    "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Actividad del equipo de soporte"])},
    "availability": {
      "online": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["🟢 Nuestro equipo está en línea"])},
      "offline": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["🔴 Nuestro equipo está teniendo algo de tiempo libre en este momento 😴, ¡pero deja tu mensaje y te responderemos lo antes posible!"])}
    },
    "status": {
      "online": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["En línea"])},
      "offline": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fuera de línea"])},
      "away": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lejos"])}
    },
    "is_typing": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("agentName")), " está escribiendo..."])}
  },
  "forms": {
    "fields": {
      "_CONTACT_NAME": {
        "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nombre"])},
        "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
      },
      "_CONTACT_EMAIL": {
        "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Correo electrónico"])},
        "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["(nombre", "@", "empresa.com)"])}
      },
      "_CONTACT_PHONE": {
        "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Teléfono"])},
        "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["es decir, 3431204000"])}
      },
      "_SUBJECT": {
        "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Asunto"])},
        "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
      },
      "_INITIAL_MESSAGE": {
        "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tu pregunta"])},
        "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
      },
      "_MESSAGE": {
        "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tu pregunta"])},
        "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
      }
    },
    "types": {
      "PRE_CHAT": {
        "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rellena el siguiente formulario para que podamos conocerte 😄"])},
        "submit-btn": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Envía tu mensaje"])},
        "default-success-msg": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gracias por dejar tu pregunta. ¡Te pondremos en contacto con uno de los miembros de nuestro equipo!"])},
        "default-error-msg": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vaya, no se pudo iniciar la conversación. ¿Puedes intentarlo de nuevo?"])}
      },
      "CONTACT_DETAILS": {
        "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Complete el siguiente formulario para que podamos estar en contacto"])},
        "submit-btn": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Enviar"])},
        "dismiss-btn": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ahora no"])},
        "default-success-msg": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gracias por proporcionar tu dirección de correo electrónico."])},
        "default-error-msg": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vaya, no se pudo enviar el formulario"])}
      },
      "EMAIL": {
        "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Envíanos unas líneas"])},
        "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Complete el siguiente formulario para ponerse en contacto con nuestro equipo de atención al cliente"])},
        "submit-btn": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Envía tu mensaje"])},
        "default-success-msg": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["¡El formulario de correo electrónico ha sido enviado!"])},
        "default-error-msg": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vaya, no se pudo entregar el correo electrónico. Vuelva a intentarlo"])}
      },
      "WHATSAPP_CONTACT": {
        "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Iniciar una conversación de WhatsApp"])},
        "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Preséntate y haz tu pregunta para que podamos ayudarte de inmediato."])},
        "submit-btn": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Envía tu mensaje"])},
        "default-success-msg": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["¡Se ha enviado el formulario de contacto de WhatsApp!"])},
        "default-error-msg": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vaya, no se pudo enviar el formulario de contacto de WhatsApp. ¿Puedes intentarlo de nuevo?"])}
      }
    }
  },
  "mailform": {
    "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Formulario de correo electrónico"])},
    "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Complete el siguiente formulario para comunicarse con nuestro equipo de atención al cliente"])},
    "fields": {
      "NAME": {
        "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nombre"])},
        "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nombre..."])}
      },
      "SUBJECT": {
        "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Asunto"])},
        "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
      },
      "QUESTION": {
        "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pregunta"])},
        "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
      },
      "EMAIL": {
        "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Email"])},
        "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
      },
      "UPLOAD": {
        "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "add_btn": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Añadir un adjunto"])}
      },
      "TOPIC": {
        "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tema"])},
        "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Seleccione..."])}
      }
    },
    "notifications": {
      "success": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["¡El formulario de correo electrónico ha sido enviado!"])},
      "errors": {
        "default": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Desafortunadamente, no se puede enviar el formulario. ¿Puedes intentarlo de nuevo?"])}
      }
    },
    "submit_btn": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Enviar mensaje"])}
  },
  "common": {
    "buttons": {
      "start_new_conversation": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Comencemos una conversación"])},
      "show_archived_conversations": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Mostrar conversaciones archivadas (", _interpolate(_named("count")), ")"])},
      "go_to_mailform": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Envía un correo electrónico en su lugar"])},
      "go_back": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Regresar"])}
    },
    "page_title": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["💬 Nuevo mensaje \"", _interpolate(_named("message")), "\""])},
    "toast": {
      "generic_error": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["¡Vaya, algo salió mal!"])},
      "message_sent_error": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ocurrió un error al enviar el mensaje"])},
      "giphy_no_results": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No se pudo encontrar ninguna imagen de Giphy"])}
    },
    "errors": {
      "upload_too_large": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["El tamaño del archivo no puede exceder los 5 MB."])},
      "upload_file_type_disallowed": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Este tipo de archivo no está permitido"])}
    }
  },
  "gdpr": {
    "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Consentimiento de cookies del RGPD"])},
    "body": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["¡Hola! Nos encantaría hablar con usted. Sin embargo, según el Reglamento general de protección de datos de la UE, primero necesitamos su aprobación para nuestro uso de información personal (por ejemplo, su nombre y dirección de correo electrónico). ¿Está de acuerdo si :<br><br>1) Almacenaremos su información personal para que podamos retomar la conversación si hablamos más tarde;<br><br>2) Es posible que le enviemos correos electrónicos para dar seguimiento a nuestra conversación aquí; <br><br>3) Es posible que le enviemos correos electrónicos sobre nuestros próximos servicios y promociones.<br>"])},
    "disapprove_body": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Está bien. Puedes ver los términos y la política en cualquier momento y dar tu consentimiento para continuar"])},
    "yes": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sí, no hay problema"])},
    "no": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No, hoy no"])}
  },
  "powered_by": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Con la tecnología de Grasp"])}
}